import React, { useState } from 'react';
import claimProjectReportsListsService from '../services/lists/claim_groups/claim_project_reports_lists.service';
import ClaimProjectReportsList from '@components/admin/claimProjectReports/ClaimProjectReportsList';
import { buildQueryString } from '../services/service';
import Pagination from '../util/Pagination';
import { Loading } from '../util';
const initialParams = {
  page: 1,
  order_by: 'report_order',
  group_projects: 'default',
  query: ''
};

/**
 * Currently this component renders the list of projects with headers as defined in the constant files for each market.
 * However in order to reuse the functionality for othe pages, that more or less render the same things, we now have the 
 * customHeaders and customColumns array properties.
 * @param {*} param0 
 * @returns 
 */
export default function ProjectsList(_ref) {
  let {
    claimGroup,
    setClaimGroup,
    additionalQueryParams = {},
    customHeaders = null,
    customColumns = null,
    accountType,
    handleToaster,
    groupProjects = 'default',
    renderExpandedRowContent = null
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [reports, setReports, totalPages, setTotalPages, params, setParams, fetchAllProjetcs] = claimProjectReportsListsService.useFetchAll({
    accountType,
    claimGroupId: claimGroup.id,
    initialQueryParams: buildQueryString({
      ...initialParams,
      ...additionalQueryParams
    }),
    setLoading,
    groupProjects
  });
  const handlePage = pageNumber => {
    window.scrollTo(0, 0);
    setParams({
      ...params,
      page: pageNumber
    });
  };
  if (!reports) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimProjectReportsList, {
    handleToaster: handleToaster,
    claimGroup: claimGroup,
    getData: fetchAllProjetcs,
    setClaimGroup: setClaimGroup,
    reports: reports,
    params: params,
    setParams: setParams,
    groupProjects: groupProjects,
    customHeaders: customHeaders,
    customColumns: customColumns,
    renderExpandedRowContent: renderExpandedRowContent
  }), /*#__PURE__*/React.createElement(Pagination, {
    currentPage: Number(params.page),
    totalPages: totalPages,
    handlePageChange: handlePage
  }));
}